import { OrganizationFeature } from '../enums/organizationFeature'

type BetaFeatures = {
  current: OrganizationFeature[]
  previous: OrganizationFeature[]
}

export const betaFeatures: BetaFeatures = {
  current: [OrganizationFeature.AccountingBasisSetting],
  previous: [
    OrganizationFeature.BillReconciliation,
    OrganizationFeature.NewBills,
    OrganizationFeature.NewBillsList,
    OrganizationFeature.CustomizeDashboard,
    OrganizationFeature.Payroll,
    OrganizationFeature.VatIntegration,
    OrganizationFeature.NewInvoicesList,
  ],
}
